<template>
  <v-btn text @click="clicked">
    <v-badge :content="counter" :value="counter" color="red lighten-1" overlap>
      <v-icon :large="large">{{ icon }}</v-icon>
    </v-badge>
    <span>{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'IconBtnWithBadge',
  props: {
    icon: String,
    text: String,
    large: Boolean,
    counter: Number,
  },
  methods: {
    clicked() {
      this.$emit('btn-click');
    },
  },
};
</script>
